import React, { useState, useEffect, useRef } from 'react';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { RAW_BASE_URL } from 'shared/config';

const ChatApp = () => {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [connected, setConnected] = useState(false);
  const { user } = useStateContext();
  const socket = useRef(null);
  const messagesEndRef = useRef(null);
  
  console.log('ChatApp', Math.random());
  
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  
  useEffect(() => {
    if(user){
      scrollToBottom();
      connectWebSocket();
    }
  }, [user]);
  
  const connectWebSocket = () => {
    // Connect to the WebSocket server
    socket.current = new WebSocket(`ws://${RAW_BASE_URL}/ws/chat/1/`);
    
    // Connection opened
    socket.current.onopen = () => {
      console.log('WebSocket connection established');
      setConnected(true);
      
      // Send a message to notify others that a new user has connected
      const connectMessage = {
        type: 'connection',
        message: `${user.username} has joined the chat`,
        username: user.username,
        timestamp: new Date().toISOString()
      };
      socket.current.send(JSON.stringify(connectMessage));
      
    };
    
    // Listen for messages
    socket.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('WebSocket message received:', data);
      const messageData = data;
      setMessages((prevMessages) => [...prevMessages, messageData]);
    };
    
    // Connection closed
    socket.current.onclose = () => {
      console.log('WebSocket connection closed');
      setConnected(false);
      
      // Attempt to reconnect after 3 seconds
      setTimeout(() => {
        connectWebSocket();
      }, 30000);
    };
    
    // Connection error
    socket.current.onerror = (error) => {
      console.error('WebSocket error:', error);
      setConnected(false);
    };
    
    // Clean up on unmount
    return () => {
      if (socket.current) {
        socket.current.close();
      }
    };
  };
  
  
  const handleSubmitMessage = (e) => {
    e.preventDefault();
    
    if (message.trim() && connected) {
      const messageObject = {
        type: 'message',
        message: message,
        username: user.username,
        timestamp: new Date().toISOString()
      };
      
      socket.current.send(JSON.stringify(messageObject));
      
      setMessage('');
    }
  };
  
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  
  
  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <div className="flex items-center justify-between px-4 py-2 bg-blue-600">
        <h1 className="text-xl font-bold text-white">Real-time Chat</h1>
        <div className="flex items-center">
          <span className={`w-3 h-3 rounded-full mr-2 ${connected ? 'bg-green-400' : 'bg-red-500'}`}></span>
          <span className="text-sm text-white">{connected ? 'Connected' : 'Disconnected'}</span>
        </div>
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-3">
          {messages.map((msg, index) => (
            <div 
              key={index} 
              className={`p-3 rounded-lg max-w-xs md:max-w-md ${
                msg.username === user.username 
                  ? 'ml-auto bg-blue-500 text-white' 
                  : msg.username === 'System'
                    ? 'mx-auto bg-gray-200 text-gray-800 text-center'
                    : 'bg-gray-300 text-gray-800'
              }`}
            >
              {msg.username !== 'system' && (
                <div className="font-semibold">
                  {msg.username === user.username ? 'You' : msg.username}
                </div>
              )}
              <div>{msg.message}</div>
              <div className="text-xs text-right mt-1 opacity-70">
                {formatTime(msg.timestamp)}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      </div>
      
      <div className="p-4 bg-white border-t">
        <form onSubmit={handleSubmitMessage} className="flex space-x-2">
          <input
            type="text"
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
            disabled={!connected}
          />
          <button
            type="submit"
            className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-blue-300 disabled:cursor-not-allowed"
            disabled={!connected || !message.trim()}
          >
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatApp;